var _unitTranslations;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { DEFAULT_ISO_LANGUAGE_REGION } from "../constants/locale.js";
import { IsoLanguagesRegions } from "../enums/locale.js";
var unitTranslations = (_unitTranslations = {}, _defineProperty(_unitTranslations, IsoLanguagesRegions.RU, {
  KB: 'КБ',
  MB: 'МБ',
  GB: 'ГБ',
  TB: 'ТБ'
}), _defineProperty(_unitTranslations, IsoLanguagesRegions.FR, {
  KB: 'Ko',
  MB: 'Mo',
  GB: 'Mdo',
  TB: 'Bno'
}), _defineProperty(_unitTranslations, IsoLanguagesRegions.BG, {
  KB: 'КБ',
  MB: 'МБ',
  GB: 'ГБ',
  TB: 'ТБ'
}), _defineProperty(_unitTranslations, IsoLanguagesRegions.RO, {
  KB: 'Ko',
  MB: 'Mo',
  GB: 'Go',
  TB: 'To'
}), _defineProperty(_unitTranslations, IsoLanguagesRegions.FI, {
  KB: 'kt',
  MB: 'Mt',
  GB: 'Gt',
  TB: 'Tt'
}), _defineProperty(_unitTranslations, IsoLanguagesRegions.TH, {
  KB: 'กิโลไบต์',
  MB: 'เมกะไบต์',
  GB: 'กิกะไบต์',
  TB: 'เทราไบต์'
}), _unitTranslations);
/**
 * Convert a file size in bytes to a human-readable string.
 *
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat
 *
 * @param options LocalizeFileSizeOptions
 * @returns string
 */
var localizeFileSize = function localizeFileSize(options) {
  var size = options.size;
  if (size === null || size === undefined || size < 0) return '';
  var isBytes = size < 1024;
  var _options$locale = options.locale,
    locale = _options$locale === void 0 ? DEFAULT_ISO_LANGUAGE_REGION : _options$locale,
    _options$numberFormat = options.numberFormatOptions,
    numberFormatOptions = _options$numberFormat === void 0 ? {
      notation: 'compact',
      style: 'unit',
      unit: 'byte',
      unitDisplay: isBytes ? 'short' : 'narrow' // matches existing Boulder for "bytes" instead of  "b"
    } : _options$numberFormat;
  var formattedEnglish = new Intl.NumberFormat(['en'], numberFormatOptions).format(size);
  // Add non breaking space between value and unit
  if (!isBytes) {
    // eslint-disable-next-line unicorn/prefer-string-replace-all
    formattedEnglish = formattedEnglish.replace(/(\d)([A-Za-z])/g, "$1\u202F$2");
  }
  // Convert BB to GB
  if (formattedEnglish.endsWith('BB')) {
    formattedEnglish = formattedEnglish.replace('BB', 'GB');
  }
  // Convert byte to B for all non english speaking languages
  if (!locale.startsWith('en') && formattedEnglish.endsWith('byte')) {
    formattedEnglish = formattedEnglish.replace('byte', 'B');
  }
  // Make byte plural when more than 1
  if (size > 1 && formattedEnglish.endsWith('byte')) {
    formattedEnglish = formattedEnglish.replace('byte', 'bytes');
  }
  // Convert unit for countries in unitTranslations object
  var translation = unitTranslations[locale] || null;
  if (translation) {
    // Convert terabytes
    if (size >= 1024 * 1000 * 1000 * 1000) {
      return formattedEnglish.replace('TB', translation.TB);
    }
    // Convert gigabytes
    if (size >= 1024 * 1000 * 1000) {
      return formattedEnglish.replace('GB', translation.GB);
    }
    // Convert megabytes
    if (size >= 1024 * 1000) {
      return formattedEnglish.replace('MB', translation.MB);
    }
    // Convert kilobytes
    if (size >= 1024) {
      return formattedEnglish.replace('KB', translation.KB);
    }
    // Return locale for bytes
    return new Intl.NumberFormat([locale], numberFormatOptions).format(size);
  }
  return formattedEnglish;
};
export { localizeFileSize };